"use client"

import { ProfilePageType } from "@/app/navigation/profile/profile-page-type"
import { useWalletConnect } from "@/app/wallet-connect/hooks"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import { Trans } from "@lingui/react/macro"
import { NavigationTabsList } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { BidsCounterReatom } from "../bids/counter/bids-counter.reatom"
import { ProfileNftsCounterBadgeReatom } from "../items/counter/index.reatom"
import { ListingsCounterReatom } from "../listings/counter/listings-counter.reatom"
import { ProfileMoleculeReatom } from "../store/index.reatom"
import { ProfilePageLink } from "./link"

interface Props {
  routes: ProfilePageType[]
}

const LINK_BY_PAGE_TYPE = {
  [ProfilePageType.ITEMS]: ItemsNavigationItem,
  [ProfilePageType.LISTINGS]: ListingsNavigationItem,
  [ProfilePageType.OFFERS]: OffersNavigationItem,
  [ProfilePageType.ACTIVITY]: ActivityNavigationItem,
}

export const ProfileNavigationViewReatom = reatomComponent<Props>(
  ({ routes }) => {
    const { walletAddress } = useMolecule(ProfileMoleculeReatom)

    return (
      <NavigationTabsList variant="tabs" className="border-b">
        {routes.map((route) => {
          const LinkComponent = LINK_BY_PAGE_TYPE[route]

          return (
            <LinkComponent key={route} profileWalletAddress={walletAddress} />
          )
        })}
      </NavigationTabsList>
    )
  },
)

interface NavigationItemProps {
  profileWalletAddress: UnionAddress
}

function ItemsNavigationItem({ profileWalletAddress }: NavigationItemProps) {
  const { address: connectedWalletAddress } = useWalletConnect()

  return (
    <ProfilePageLink
      walletAddress={profileWalletAddress}
      pageType={ProfilePageType.ITEMS}
    >
      <div className="flex gap-1">
        <Trans>Items</Trans>
        <ProfileNftsCounterBadgeReatom />
      </div>
    </ProfilePageLink>
  )
}

function ListingsNavigationItem({ profileWalletAddress }: NavigationItemProps) {
  return (
    <ProfilePageLink
      walletAddress={profileWalletAddress}
      pageType={ProfilePageType.LISTINGS}
    >
      <div className="flex gap-1">
        <Trans>Listings</Trans>
        <ListingsCounterReatom />
      </div>
    </ProfilePageLink>
  )
}

function OffersNavigationItem({ profileWalletAddress }: NavigationItemProps) {
  return (
    <ProfilePageLink
      walletAddress={profileWalletAddress}
      pageType={ProfilePageType.OFFERS}
    >
      <div className="flex gap-1">
        <Trans>Offers</Trans>
        <BidsCounterReatom />
      </div>
    </ProfilePageLink>
  )
}

function ActivityNavigationItem({ profileWalletAddress }: NavigationItemProps) {
  return (
    <ProfilePageLink
      walletAddress={profileWalletAddress}
      pageType={ProfilePageType.ACTIVITY}
    >
      <Trans>Activity</Trans>
    </ProfilePageLink>
  )
}
